// Existing public geography source, paged without guessing missing locations.
export async function collectListingNeighborhoods(loadPage){
 const result=[],seen=new Set();
 for(let page=1;page<=100;page++){
  const response=await loadPage(page);
  if(!Array.isArray(response?.items)||typeof response.hasMore!=='boolean'||response.page!==page)throw new Error('Invalid geography response');
  for(const item of response.items){const id=String(item?._id||'');if(!id||seen.has(id))throw new Error('Invalid geography response');seen.add(id);result.push(item);}
  if(!response.hasMore)return result;
  if(!response.items.length)throw new Error('Invalid geography response');
 }
 throw new Error('Too many geography choices. Narrow the source data before retrying.');
}
